// Store listings for the B-Reporter app ("My News My Report" on both stores).
export const ANDROID_PACKAGE = 'com.iitd.breporter3';
export const PLAY_STORE_URL = `https://play.google.com/store/apps/details?id=${ANDROID_PACKAGE}`;
export const APP_STORE_URL = 'https://apps.apple.com/in/app/my-news-my-report/id6744141391';

export type DeviceOS = 'iOS' | 'Android' | 'other';

export const detectOS = (): DeviceOS => {
	if (typeof window === 'undefined') return 'other';
	const ua = window.navigator.userAgent || '';
	// iPadOS 13+ reports itself as a Mac; the touch points give it away.
	if (/iPad|iPhone|iPod/.test(ua) || (/Macintosh/.test(ua) && navigator.maxTouchPoints > 1)) return 'iOS';
	if (/Android/i.test(ua)) return 'Android';
	return 'other';
};

export const storeUrlFor = (os: DeviceOS) => (os === 'iOS' ? APP_STORE_URL : PLAY_STORE_URL);

/**
 * Opens the installed app, or its store listing when it isn't installed.
 *
 * Android: an intent:// link on the app's `breporter` scheme. Chrome launches
 * the app when an installed build declares that scheme, and otherwise follows
 * browser_fallback_url to the Play listing (which itself shows "Open" for
 * older installed builds that predate the scheme). Browsers and in-app
 * webviews that ignore intent:// links are caught by the timer: if the page is
 * still in the foreground shortly after, nothing took over and we go to the
 * Play listing ourselves.
 *
 * iOS: the App Store page, which shows "Open" when the app is installed. A
 * custom-scheme attempt would make Safari show an "address is invalid" alert
 * for everyone without the app.
 */
export const openAppOrStore = (os: DeviceOS) => {
	if (os !== 'Android') {
		if (os === 'iOS') window.location.href = APP_STORE_URL;
		else window.open(PLAY_STORE_URL, '_blank', 'noopener');
		return;
	}

	const intentUrl =
		`intent://report#Intent;scheme=breporter;package=${ANDROID_PACKAGE};` +
		`S.browser_fallback_url=${encodeURIComponent(PLAY_STORE_URL)};end`;

	const timer = window.setTimeout(() => {
		if (document.visibilityState === 'visible') window.location.href = PLAY_STORE_URL;
	}, 2500);
	const cancel = () => {
		if (document.visibilityState === 'hidden') window.clearTimeout(timer);
	};
	document.addEventListener('visibilitychange', cancel, { once: true });
	window.addEventListener('pagehide', () => window.clearTimeout(timer), { once: true });

	window.location.href = intentUrl;
};
